export default __webpack_public_path__ + "static/media/reset.f97de43b.svg";